module.exports = __webpack_public_path__ + "static/media/Integral.5e7e8f12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/Integral.jpg
// module id = 479
// module chunks = 0